var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "mt-3 mb-2 elevation-2",
    attrs: {
      headers: _vm.headers,
      items: _vm.tasks,
      loading: _vm.loading,
      "loading-text": "",
      "items-per-page-text": _vm.$t("tables.RowsPerPage"),
      "items-per-page-items": [5, 10, 25, { text: _vm.$t("All"), value: -1 }],
      "header-props": { sortIcon: "mdi-menu-down" },
      "footer-props": { prevIcon: "mdi-menu-left", nextIcon: "mdi-menu-right" }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                on: {
                  click: function($event) {
                    return _vm.openTask(props.item)
                  }
                }
              },
              [
                _c(
                  "td",
                  [
                    _c("activity-task-status-icon", {
                      attrs: {
                        status: props.item.state,
                        delayed: _vm.isDelayed(props.item)
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.title))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.getUserName(props.item.user_assignee_id)))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.getFormattedDate(props.item.scheduled_date))
                  )
                ])
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65346edc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65346edc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/ActivityDetails/ActivityDetailsTasks.vue
// module id = null
// module chunks = 